import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TopicListEffects } from './topic-list.effects';
import { initialState, reducer } from './topic-list.reducer';
import { createLocalStorageSyncReducer } from '../local-storage-sync';
import { TopicListState } from './topic-list.state';
import { getEnvironment } from '../../features/shared/utils/get-environment';

const syncMetaReducer = createLocalStorageSyncReducer<TopicListState>({
  keys: ['collapsedTopics', 'showDescriptions'],
  rehydrate: true,
  storage: localStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('topicList', reducer, { initialState, metaReducers: [syncMetaReducer] }),
    EffectsModule.forFeature([TopicListEffects]),
  ],
  providers: [TopicListEffects],
})
export class TopicListStoreModule {}
